<template>
  <div>
        <el-drawer
            class="drawer"
            :visible.sync="cliquenumber"
            :show-close="false"
            ref="drawerRef"
            size="500px"
            @close="$emit('closeDrawer')"
            direction="rtl">
        <!-- 标题 -->
         <div class="team-list">
            <div class="team-title-box">
                <div class="team-title">
                    <div>
                        <div class="team-title-tiem">{{select_time.select_time | formatTimestamp(2)}}</div>
                        <div class="team-title-name">{{select_time.teamConfirmation>0?'团队确认':'客房余量'}}</div>
                    </div>
                    <div class="dayDate-top-close" @click="$emit('closeDrawer')">
                        <i class="el-icon-close"></i>
                    </div>
                </div>
                <div class="room-number">
                    <div class="single">
                        <p>单人间</p>
                        <p class="single-num">{{ select_time.s_num1 || 0 }}</p>
                        <P class="single-percent">已占 {{ select_time.b_num1 || 0 }}间</P>
                    </div>
                    <div class="double">
                        <p>双人间</p>
                        <p class="single-num">{{ select_time.s_num2 || 0 }}</p>
                        <P class="single-percent">已占 {{ select_time.b_num2 || 0 }}间</P>
                    </div>
                </div>
                <!--预订团队-->
                <div class="team-number" v-if="select_time.teamConfirmation>0">
                    <div class="team-number-num"><i class="el-icon-date"></i>当日团队确认({{select_time.teamConfirmation || 0}})</div>
                </div>
                <div class="team-number" v-else>
                    <div class="team-number-num" v-if="select_time.team_num>0"><i class="el-icon-date"></i>当日预订团队({{select_time.team_num || 0}})</div>
                    <div class="team-number-team"  v-else><i class="el-icon-date"></i>当日无预订团队</div>
                </div>
            </div>
            <!--团队列表-->
            <ul class="teamBooking-list">
                <li v-for="item in list" :key="item.team_id" >
                    <div>
                        <div class="teamBooking-list-name">{{ item.travel_title||item.send_name }}</div>
                        <div class="teamBooking-list-time">入住:{{item.date_in | formatTimestamp(7)}} 离店:{{item.date_out | formatTimestamp(7)}} ({{item.date_in | getDayInterval(item.date_out)}}晚丨{{item.num}}人)</div>
                        <div class="teamBooking-list-room"  v-if="item.order_type==1">间数:{{item.room_need_arr.num}}</div>
                        <div v-else>纯会议</div>
                    </div>
                    <!--状态提示-->
                    <div class="status-prompt" v-if="item.edit_status==1||item.cancel_status==1">
                        <div v-if="item.edit_status==1">修改中</div>
                        <div v-if="item.cancel_status==1">取消中</div>
                    </div>
                    <div class="status-prompt" v-if="select_time.teamConfirmation>0">
                        <div>待确认</div>
                    </div>
                    <div class="teamBooking-list-icon">
                        <i class="el-icon-arrow-right"></i>
                    </div>
                </li>
            </ul>
            <div :class="{'designate':list.length>=1}" v-if="!select_time.past">
                <el-button type="primary" @click="$emit('modifyaddRoom',select_time)"  style="width: 94%;" icon="el-icon-edit">修改当日余量</el-button>
            </div>
        </div>
     </el-drawer>
  </div>
</template>

<script>
import {mapActions} from 'vuex'
export default {
  name: '',
  components: {},
  props: {
    select_time: {
        type: Object,
        default: () => {}
    },
    cliquenumber: {
        type: Boolean,
        default: false
    }
  },
  data() {
    return {
        formData: {
            num: 10,
            page:1,
        },
        list: [],
        hasMore: true,   // 是否还有更多数据
        loading: true,   // 加载中状态（防抖）
    };
  },
  computed: {},
  watch: {
    select_time: {
      handler(newVal){
        console.log(newVal.team_num)
        if(newVal.team_num||newVal.teamConfirmation){
            this.list=[]
            this.hasMore = true;
            this.loading = true;
            this.formData.page=1;
            this.POST_HotelsTeamList()
        }
      },
      deep: true,
      immediate: true
    },
    cliquenumber(val){
        console.log(val)
        if(val){
            // 抽屉打开，DOM渲染完成后绑定滚动
            this.$nextTick(() => {
            const bodyDom = this.$refs.drawerRef.$el.querySelector('.el-drawer__body')
            if (bodyDom) {
                bodyDom.addEventListener('scroll', this.handleDrawerScroll)
            }
            })
        }else{
            // 抽屉关闭，移除滚动事件
            this.$nextTick(() => {
            const bodyDom = this.$refs.drawerRef.$el.querySelector('.el-drawer__body')
            if (bodyDom) {
                bodyDom.removeEventListener('scroll', this.handleDrawerScroll)
            }
            })
        }
    },
  },
  created() {},
  mounted() {},
  methods: {
    ...mapActions(['HotelsTeamList','POST_OrderHotelListConfirmHandle','POST_OrderHotelListConfirmHandle']),
    POST_HotelsTeamList(){
        // 标记为加载中，防止重复请求
        this.loading = true;
        let url='HotelsTeamList';
        if(this.select_time.teamConfirmation){
            url='POST_OrderHotelListConfirmHandle'
        }
        this[url]({
            data: {
                [this.select_time.teamConfirmation?'date_in':'select_time']: this.select_time.select_time,
                ...this.formData
            },
            successFun: (res) => {
                const newData = res.list; // 接口返回的新数据
                const total = res.count;  // 接口返回的总数据量（可选)
                this.list = [...this.list, ...newData] || []
                this.hasMore = this.formData.page * this.formData.num < total
                this.formData.page=newData.length>0?this.formData.page+1:this.formData.page
                this.loading = false
                this.$nextTick(() => {
                    // 确保DOM更新完成后再绑定滚动事件
                    this.$refs.drawerRef.$el.querySelector('.el-drawer__body').addEventListener('scroll', this.handleDrawerScroll)
                })
            }
        })
    },
    // 处理滚动事件
    handleDrawerScroll(e) {
      const { scrollTop, scrollHeight, clientHeight } = e.target
      // 容错10px，解决浏览器小数滚动精度问题
      const isReachBottom = scrollTop + clientHeight >= scrollHeight - 10

      if (isReachBottom && !this.loading) {
        // 无更多数据或正在加载时，阻止重复请求
        if (!this.hasMore || this.loading) return;
            this.POST_HotelsTeamList()
      }
    },
    }
};
</script>

<style lang="scss" scoped>
    .team-list{
        width: 100%;
        height: 100%;
        background-color:var(--smtc-color-back);
        margin: 0 auto;
        position: relative;
    }
    .designate{
        position: sticky;
        bottom: 0;
        left: 0;
        width: 100%;
    }
    .team-title{
        text-align: left;
        display: flex;
        justify-content: space-between;
        width: 94%;
        background-color: #fff;
        padding: 0 3%;
        padding-bottom: 10px;
        margin: 0 auto;
    }
    .team-title-tiem{
        color: #999;
    }
    .team-title-name{
        font-weight: bold;
        font-size: 18px;
    }
    .dayDate-top-close{
        width: 30px;
        height: 30px;
        background-color: var(--smtc-color-back);
        text-align: center;
        line-height:30px;
        border-radius: 50px;
        margin-right: 6px;
        margin-top: 6px;
        cursor: pointer;
    }
    .room-number{
        width: 94%;
        margin: 20px auto;
        display: flex;
        justify-content: space-between;
        text-align: left;
    }
    .room-number .single{
        background-color: #eff9ff;
        width: 40%;
        padding: 3% 4%;
        border-radius: 4px;
    }
    .room-number .double{
        background-color: #fff7e6;
        width: 42%;
        padding: 3% 4%;
        border-radius: 4px;
    }
    .single-num{
        font-size: 24px;
        font-weight: bold;
    }
    .double .single-num{
        color: #fa9988;
        margin: 6px 0;
    }
    .single .single-num{
        color: #429dff;
        margin: 6px 0;
    }
    .single-percent{
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #999;
    }
    .team-number{
        width: 94%;
        text-align: left;
        margin: 20px auto;
        i{
            margin-right: 6px;
            color: #999;
        }
    }
    .teamBooking-list{
        text-align: left;

        overflow: auto;
        li{
            width: 88%;
            padding:4%;
            background-color: #eff9ff;
            margin: 20px auto;
            border-radius: 4px;
            position: relative;
            padding-left: 8%;
            display: flex;
            justify-content: space-between;
            &::after{
                content: '';
                position: absolute;
                top: 15%;
                left: 3%;
                width: 4px;
                height: 70%;
                background-color: #429dff;
                border-radius: 3px;
            }
            &:nth-child(1){
                margin-top: 0;
            }
        }   
    }
    .teamBooking-list-name{
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 4px;
    }
    .teamBooking-list-time{
        color: #999;
    }
    .teamBooking-list-room{
        color:var(--smtc-color-primary);
        font-weight: bold;
        margin-top: 6px;
    }
    .teamBooking-list-icon{
        display: flex;
        margin-top: 31px;
        color: #999;
    }
    .status-prompt{
        margin-left: auto;
        background-color: var(--smtc-color-text-paleRed);
        color: #fff;
        height: 28px;
        font-size: 12px;
        width: 45px;
        text-align: center;
        line-height: 28px;
        border-radius: 4px;
        margin-top: 24px;
        margin-right: 10px;
    }
    .team-title-box{
        position: sticky;
        top: 0;
        left: 0;
        background-color: var(--smtc-color-back);
        z-index: 3;
        overflow: hidden;

    }
</style>
